export function user(state = null, action) {
	switch (action.type) {
		case 'UPDATE_USER':
			return action.user
		default:
			return state
	}
}